angular.module('unica_hospitality.hospitality_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// HOSPITALITY
		.state('app.hospitality', {
			url: '/hospitality',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/hospitality/templates/hospitality.html',
					controller: 'HospitalityBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// HOSPITALITY DASHBOARD
			.state('app.hospitality.dashboard', {
				url: '/dashboard',
				views: {
					'hospitalityContent': {
						templateUrl: './modules/hospitality/templates/dashboard.html',
						controller: 'HospitalityDashboardController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Hospitality'
				}
			});




});

